module.exports = __webpack_public_path__ + "static/media/imgPoC.855d1c2a.svg";